"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVersionCheckRequestDtoPlatformEnum = void 0;
exports.instanceOfAppVersionCheckRequestDto = instanceOfAppVersionCheckRequestDto;
exports.AppVersionCheckRequestDtoFromJSON = AppVersionCheckRequestDtoFromJSON;
exports.AppVersionCheckRequestDtoFromJSONTyped = AppVersionCheckRequestDtoFromJSONTyped;
exports.AppVersionCheckRequestDtoToJSON = AppVersionCheckRequestDtoToJSON;
exports.AppVersionCheckRequestDtoToJSONTyped = AppVersionCheckRequestDtoToJSONTyped;
/**
 * @export
 */
exports.AppVersionCheckRequestDtoPlatformEnum = {
    Ios: 'ios',
    Android: 'android'
};
/**
 * Check if a given object implements the AppVersionCheckRequestDto interface.
 */
function instanceOfAppVersionCheckRequestDto(value) {
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined)
        return false;
    return true;
}
function AppVersionCheckRequestDtoFromJSON(json) {
    return AppVersionCheckRequestDtoFromJSONTyped(json, false);
}
function AppVersionCheckRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'platform': json['platform'],
        'currentVersion': json['currentVersion'],
    };
}
function AppVersionCheckRequestDtoToJSON(json) {
    return AppVersionCheckRequestDtoToJSONTyped(json, false);
}
function AppVersionCheckRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'platform': value['platform'],
        'currentVersion': value['currentVersion'],
    };
}
